import React, { useEffect } from "react";
import { useLoginFlow } from "@jugl-web/utils";
import { useSelector } from "react-redux";
import { selectAuthState } from "@web-src/features/auth/authSlice";
import { NavigateToDefaultEntity } from "@web-src/features/app/components/NavigateToDefaultEntity/NavigateToDefaultEntity";
import { CXOnboardingFlow } from "../../components/CXOnboardingFlow";

const CXLoginPageContent: React.FC = () => {
  const { setLoginFlow } = useLoginFlow();

  useEffect(() => {
    setLoginFlow("cx");
  }, [setLoginFlow]);

  return <CXOnboardingFlow initialStep="credentials" showCarousel />;
};

export const CXLoginPage: React.FC = () => {
  const { isAuthenticated } = useSelector(selectAuthState);

  if (isAuthenticated) {
    return <NavigateToDefaultEntity />;
  }

  return <CXLoginPageContent />;
};
